const genAnswer = function (qu, value, refItem) {
  const optionList = qu.optionList
  return value.map(item => {
    return {
      descId: refItem.id,
      answer: item,
      otherAnswer: optionList.find(opt => opt.id === item) && optionList.find(opt => opt.id === item).otherValue || ''
    }
  })
}

const setAnswer = function (qu, valueMap, otherAnswerMap, extendsDataMap, answerList = []) {
  const value = []
  const { optionList, descList, descIndex } = this
  const descObj = descList[descIndex]
  if (descObj) {
    const id = descObj.id
    answerList = answerList.filter(item => item.descId === id)
    if (answerList.length) {
      answerList.forEach(item => {
        const { answer, otherAnswer } = item
        value.push(answer)

        if (optionList.find(opt => opt.id === answer)) {
          optionList.find(opt => opt.id === answer).otherValue = otherAnswer
        }
      })
    }
    descObj.value = value
  }
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/CheckBoxGroup/answer.js